import { Component, ViewEncapsulation, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * Prototype-style shell for Material tables. Project table markup and paginator as children.
 * Uses ViewEncapsulation.None so styles apply to projected mat-table content.
 */
@Component({
  selector: 'lr-data-table',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="lr-data-table" [class.lr-data-table--loading]="loading()">
      @if (loading() && loadingOverlay()) {
        <div class="lr-data-table-overlay" aria-hidden="true">
          <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
        </div>
      }
      <ng-content />
    </div>
  `,
  styleUrl: './data-table.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DataTableComponent {
  loading = input(false);
  loadingOverlay = input(true);
}
